<template>
  <div>
    <div class="member-wrap" v-if="isMember" :class="namespaceGroup">
      <Tab
        :mainCardList="mainCardList"
        :currentGroup="currentGroup"
        :handleCardClick="handleCardClick"
        :currentCard="currentCard"
        :handleTabClick="handleTabClick"
      />
      <template v-if="!loading">
        <component
          :is="showWitchComponent(item)"
          v-for="item of categoryList"
          :card="card"
          :key="item.id"
          :item="item"
          :type="item.display_code"
          :namespace="namespace"
          v-show="handleShowComponent(item)"
        />
        <div class="action-wrap">
          <div class="order" @click="handleToOrder">
            <svg-icon
              :iconClass="currentGroup.order || 'bj-service-by'"
            />我的订单
          </div>
          <div class="line"></div>
          <div class="service" @click="handleToService">
            <svg-icon
              :iconClass="currentGroup.server || 'bj-order-by'"
            />客服中心
          </div>
        </div>
      </template>
    </div>
    <van-empty
      v-else-if="!isMember"
      class="member-wrap"
      description="您还不是会员，请开通会员后使用"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import qs from "qs";
import Vue from "vue";

import { useStore, useRouter, useRoute } from "@/components/use/base";

import WxjkHeader from "@/views/index/moreCard/visitor/component/wxjk/WxjkHeader.vue";
import HbHeader from "@/views/index/moreCard/visitor/component/common/HbHeader.vue";
import HbBenefit from "@/views/index/moreCard/visitor/component/common/HbBenefit.vue";
import useMoreCard from "@/use/useMoreCard";

import Header from "../component/header.vue";
import Tab from "../component/Tab.vue";
import benefit from "../component/benefit.vue";
import BjHeader from "../component/header.vue";
import benefitMore from "../component/benefitMore.vue";
import SaveMoneyHeader from "../component/SaveMoneyHeader.vue";
import BenefitVisitor from "../component/BenefitVisitor.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    BjHeader,
    benefit,
    benefitMore,
    SaveMoneyHeader,
    BenefitVisitor,
    Tab,
    WxjkHeader,
    HbHeader,
    HbBenefit,
    Header,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const {
      initMoreCard,
      setStoreAndStorage,
      getCardList,
      card,
      categoryList,
      currentCard,
      mainCardList,
      currentGroup,
    } = useMoreCard();

    const loading = ref(true);

    const namespace = computed(() => store.state.namespace);
    const isMember = computed(() => store.state.isMember);
    const namespaceGroup = computed(() => {
      if (/^\d/.test(store.state.namespaceInfo.namespace_group_en))
        return `xshk-${store.state.namespaceInfo.namespace_group_en}`;
      return store.state.namespaceInfo.namespace_group_en;
    });

    const showWitchComponent = computed(() => (item) => {
      if (["benefitMoreimage", "benefitMore"].includes(item.display_code))
        return "benefitMore";
      if (
        [
          "WxjkHeader",
          "BjHeader",
          "SaveMoneyHeader",
          "BenefitVisitor",
          "HbHeader",
          "HbBenefit",
          "Header",
        ].includes(item.display_code)
      )
        return item.display_code;
      return "benefit";
    });

    // 如果不是合法权益就不展示楼层
    const handleShowComponent = computed(() => (item) => {
      if (["HbHeader", "WxjkHeader", "Header"].includes(item.display_code)) {
        return true;
      }
      const productInfo = item.productInfo;
      const benefitList = card.value.benefit_list.map((item) => item.type);
      let show = true;
      if (
        !["benefitMore", "benefitMoreimage", "HbBenefit"].includes(
          item.display_code
        )
      ) {
        productInfo.forEach((element) => {
          if (!benefitList.includes(element.benefit_type)) show = false;
        });
      } else {
        show = false;
        productInfo.forEach((element) => {
          if (benefitList.includes(element.benefit_type)) show = true;
        });
      }
      return show;
    });

    onMounted(async () => {
      const loadingPage = vm.$loading();
      loading.value = true;
      try {
        if (
          ["weixinjinke", "huanbei"].includes(namespaceGroup.value) &&
          !isMember.value
        ) {
          const params = qs.stringify(route.query);
          router.replace(`/visitor?${params}`);
          return;
        }
        if (["oapromotion"].includes(namespaceGroup.value) && !isMember.value) {
          router.replace("/saveMoneyCard?namespace=" + namespace.value);
          return;
        }
        await getCardList();
        await initMoreCard();
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
        loadingPage.clear();
      }
    });

    const handleCardClick = async (item) => {
      if (currentCard.value.namespace === item.namespace) return;
      currentCard.value = item;
      await setStoreAndStorage(item.token, item.namespace);
      await initMoreCard();
    };

    const handleToOrder = () => {
      router.push("/order");
    };

    const handleTabClick = async (item) => {
      if (currentGroup.value.group === item.group) return;
      currentGroup.value = item;
      currentCard.value = item.children[0];
      await setStoreAndStorage(
        item.children[0].token,
        item.children[0].namespace
      );
      await initMoreCard();
    };

    const handleToService = () => {
      router.push("/help");
    };

    return {
      categoryList,
      card,
      currentCard,
      loading,
      namespace,
      isMember,
      mainCardList,
      currentGroup,
      showWitchComponent,
      handleShowComponent,
      namespaceGroup,
      handleCardClick,
      handleToOrder,
      handleToService,
      handleTabClick,
    };
  },
});
</script>

<style lang="less" scoped>
.member-wrap {
  overflow: hidden;

  &.xshk-58sk {
    background: #fff;
  }
}

.huanbei {
  padding-bottom: 32px;
  background: #fff;

  .action-wrap {
    background: #f8f8f8;
    margin-bottom: 0;
  }
}

.oapromotion {
  min-height: 100vh;
  background: url("https://common-h5-dev.xiangshuheika.com/static/upload/2025081895af9c5f18a69.png")
    no-repeat;
  background-size: 100% !important;
  box-sizing: border-box;
  overflow: hidden;
}

.weixinjinke {
  background: #fff;
  overflow: hidden;

  .action-wrap {
    overflow: hidden;
    background: #f8f8f8;
    margin-top: 24px;
    margin-bottom: 24px;
  }
}

.action-wrap {
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 31px;

  display: flex;
  align-items: center;
  width: 343px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;

  font-weight: 400;
  font-size: 15px;
  color: #333333;

  svg {
    height: 20px;
    width: 22px;
    margin-right: 9px;
  }

  .order {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .line {
    width: 1px;
    height: 23px;
    background: #e4e4e4;
  }

  .service {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
}
</style>
